import { addCommasToNumber, GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useState } from 'react'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { SimpleRow } from '@components/InventoryValuation/Costing/Details/SimpleRow'
import { sumBy } from 'lodash'
import { colorTypeMatch } from './util'
import type { AdditiveDrawsProps } from './types'

export const AdditiveDraws = ({ draws, formattedCurrency, showDate }: AdditiveDrawsProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  if (!draws?.length) return
  return (
    <>
      <Horizontal
        className='p-2'
        style={{ background: colorTypeMatch.ADDITIVE_ADJUSTMENT.bg, borderTop: '2px solid var(--theme-warning)' }}
        verticalCenter
      >
        <GraviButton
          className='p-2 collapse-arrow'
          title={isExpanded ? 'Collapse' : 'Expand'}
          icon={isExpanded ? <DownOutlined /> : <RightOutlined />}
          onClick={() => setIsExpanded(!isExpanded)}
        />

        <Texto className='additive-draws-title text-error' weight={'bold'}>
          ADDITIVE DRAWS
        </Texto>
        <Vertical className='pr-2' flex={7} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {addCommasToNumber(Math.abs(sumBy(draws, 'volume')), 0)}
          </Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {formattedCurrency}
            {addCommasToNumber(Math.abs(sumBy(draws, 'price')), 4)}
          </Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {formattedCurrency}
            {addCommasToNumber(Math.abs(sumBy(draws, 'value')), 2)}
          </Texto>
        </Vertical>
      </Horizontal>
      {isExpanded &&
        draws.map((draw, index) => {
          return (
            <SimpleRow
              row={draw}
              formattedCurrency={formattedCurrency}
              showDate={showDate}
              key={`additive-draws-${index}`}
              isDraw
              isAdjustment
            />
          )
        })}
    </>
  )
}
